module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ACE OF THE BLACK CROSS")])]), _vm._v(" "), _c('p', {
    staticClass: "titlea"
  }, [_vm._v("ERNST UDET")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Introduction by")])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("RICHARD OVERY")]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "alt": "images",
      "src": "images/f0iii-01.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42429cfd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Title.vue
// module id = 63
// module chunks = 0